import { render, staticRenderFns } from "./add-friend.vue?vue&type=template&id=23163370&scoped=true&"
import script from "./add-friend.vue?vue&type=script&lang=js&"
export * from "./add-friend.vue?vue&type=script&lang=js&"
import style0 from "./add-friend.vue?vue&type=style&index=0&id=23163370&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23163370",
  null
  
)

export default component.exports